import {
  _object,
  _optionalNullable,
  _string,
  _number,
  _optional,
  _array,
} from '@shopee-user/schema-formatter';

import { businessAccountSchema } from '@shopee-user/account-constants';

export const changePhoneResponseSchema = _object(
  {
    nonce: _optionalNullable(_string),
    account: _optionalNullable(businessAccountSchema),
    disallow_reason: _optionalNullable(_number), // only returned when error is ERROR_PHONE_UPDATE_DISALLOWED = 48401126
  },
  { tag: 'ChangePhone' }
);

export const changeEmailResponseSchema = _object(
  {
    nonce: _optionalNullable(_string),
    account: _optionalNullable(businessAccountSchema),
    disallow_reason: _optionalNullable(_number), // only returned when error is EmailUpdateDisallowed = 48401129
  },
  { tag: 'ChangeEmail' }
);

export const changeEmailInitResponseSchema = _object(
  {
    disallow_reason: _optionalNullable(_number), // only returned when error is EmailUpdateDisallowed = 48401129
    change_toc_credential_id: _optional(_string),
  },
  { tag: 'ChangeEmailInit' }
);

// https://confluence.shopee.io/display/SAUT/%5BTD%5D%5B20250707%5D+SPX+NSS+Third+Party+Login+-+Login+with+Shopee#heading-61getthirdpartystatus
const ThirdpartyIntegrationLinkSchema = _object(
  {
    third_party_type: _number, // 1 - shopee
    third_party_identity: _optional(_string), // could be shopee userid or thirdparty userid
  },
  { tag: 'ThirdpartyIntegrationLink' }
);

export const getIntegrationLinkListResponseSchema = _object(
  {
    integration_links: _optionalNullable(
      _array(ThirdpartyIntegrationLinkSchema)
    ),
  },
  { tag: 'GetIntegrationLinkList' }
);
